import { type FC } from "react";

import clsx from "clsx";
import { TokenIcon, TokenIconSize } from "~/components/index";
interface Props {
    className?: string;
    size?: TokenIconSize;
    tailIconSize?: TokenIconSize;
    tailIconClass?: string;
    chainIcon?: string;
    icon: string;
    symbol: string;
    withoutTail?: boolean;
    tokenIconBorder?: boolean;
    chainName?: string;
}

export const TokenBadge: FC<Props> = (Props: Props) => {
    const {
        chainIcon,
        chainName,
        className,
        icon = "",
        symbol,
        withoutTail = false,
        tokenIconBorder = false,
        size,
        tailIconSize,
        tailIconClass = "",
    } = Props;

    return (
        <div className={clsx("relative", className)}>
            <TokenIcon
                size={size}
                icon={icon}
                symbol={symbol}
                tailIconClass={clsx({
                    "border-[1px] border-border_1": tokenIconBorder,
                })}
            />
            {!withoutTail && chainIcon && (
                <div
                    className={clsx(
                        "absolute -bottom-[3px] -right-[3px] rounded-full bg-bg_0 flex items-center justify-center"
                    )}
                >
                    <TokenIcon
                        icon={chainIcon}
                        size={tailIconSize || "mini"}
                        symbol={chainName || symbol}
                        tailIconClass={clsx(
                            "border-[2px] border-bg_0",
                            tailIconClass
                        )}
                    />
                </div>
            )}
        </div>
    );
};
